// Use for build
export default "/howdidyou2020/html/";
// Use for dev
//export default "/";
